import React from 'react';
import { useTranslation } from 'react-i18next';
import { getThemeColors } from '../../lib/theme';
import { formatDate } from '../../lib/dateFormat';

/** Platzhalter, an dem der Text für das fett gesetzte Datum geteilt wird. */
const DATE_MARK = '\u0000DATE\u0000';

/** Status „Bestätigt". */
const CARE_STATUS_CONFIRMED = 2;

/**
 * Erklärtext unter „BK und PB per E-Mail benachrichtigen" (Ticket cmuy4wq2y):
 * Mit Status „Bestätigt" setzt die API das nächste Startdatum des PB
 * automatisch auf das Ende dieser Betreuung — ohne Checkbox (ersetzt die
 * frühere Checkbox „Das neue Startdatum auf den … verlegen"). Bei
 * „Bestätigt" mit Enddatum zeigt der Hinweis das konkrete Datum fett.
 */
export function StartdatumAutoHint({
  dark, status, enddatum,
}: {
  dark: boolean;
  status: number;
  /** Enddatum der Betreuung (YYYY-MM-DD) oder leer. */
  enddatum: string;
}) {
  const tc = getThemeColors(dark);
  const { t } = useTranslation();
  const active = status === CARE_STATUS_CONFIRMED && !!enddatum;
  const [before, after = ''] = t('pflege.cares.startdatum_auto_preview', { date: DATE_MARK }).split(DATE_MARK);
  return (
    <div data-testid="care-startdatum-auto-hint" style={{ fontSize: 12, color: tc.muted, lineHeight: 1.4, marginTop: -6 }}>
      {t('pflege.cares.startdatum_auto_hint')}
      {active && (
        <div data-testid="care-startdatum-auto-preview" style={{ color: tc.text, marginTop: 2 }}>
          {before}<strong>{formatDate(enddatum, enddatum)}</strong>{after}
        </div>
      )}
    </div>
  );
}
